export default __webpack_public_path__ + "cfdd5788a18adea235c747ef9a7665b1.png";